import React from 'react';
import { Select, Option, ClusterLayout, Text } from '@mc/wink';
import { TranslateResultsPerPage } from './TranslateResultsPerPage';
import stylesheet from './ResultsPerPage.css';

const getPaginationRangeText = (
  currentPage: number,
  itemsPerPage: number,
  totalItems: number,
) => {
  const startItem = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  return `${startItem}-${endItem}`;
};

export type ResultsPerPageProps = {
  onChange: (value: number) => void;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  perPageOptions: number[];
};

const ResultsPerPage = ({
  onChange,
  itemsPerPage,
  currentPage,
  totalItems,
  perPageOptions,
}: ResultsPerPageProps) => {
  const { ofText, resultsText } = TranslateResultsPerPage(totalItems);
  const rangeText = getPaginationRangeText(
    currentPage,
    itemsPerPage,
    totalItems,
  );

  const handleOnChange = (value: $TSFixMe) => {
    onChange(value as number);
  };

  return (
    <ClusterLayout gap={3}>
      <Select
        label={resultsText}
        hideLabel
        size="medium"
        mode="listbox"
        value={itemsPerPage}
        renderSelectedValue={() => {
          return `${itemsPerPage} / page`;
        }}
        onChange={handleOnChange}
        className={stylesheet.resultsPerPageSelect}
      >
        {perPageOptions.map((perPage) => (
          <Option key={perPage} value={perPage} label={perPage.toString()}>
            {perPage}
          </Option>
        ))}
      </Select>
      <div role="status" aria-live="polite">
        <Text as="span" appearance="small">
          {rangeText}
        </Text>
        <Text as="span" appearance="small-tertiary">
          {ofText}
        </Text>
        <Text as="span" appearance="small">
          {totalItems}
        </Text>
      </div>
    </ClusterLayout>
  );
};

export default ResultsPerPage;
